import { Component } from '@angular/core';

@Component({
  selector: 'app-shared-components-animations-type-cursor',
  templateUrl: './shared-components-animations-type-cursor.component.html',
  styleUrls: ['./shared-components-animations-type-cursor.component.scss']
})
export class SharedComponentsAnimationsTypeCursorComponent {}
